/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const ReassingnCLevel = (props) => {
  const [disabled, setDisabled] = useState(true);
  const [zPos, setZPos] = useState(45)
  const [form, setForm] = useState({
    agent_uuid: "",
    customers: [],
  });
  const [error, setErrors] = useState({
    agent_uuid: "",
  });

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    f[field] = e.target.value;
    if (!e.target.value) {
      er.agent_uuid = "Selecciona un agente";
    } else {
      er.agent_uuid = "";
    }

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er);
  };

  const validateForm = (f, err) => {
    if (f["agent_uuid"] && !err["agent_uuid"]) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const reassign = () => {
		props.changeLoader(true);
		setZPos(-1)
    let customers = [];
    for (let i = 0; i < props.contentModal.customers.length; i++) {
			customers.push(props.contentModal.customers[i]["uuid"]);
    }
    props.reassign(customers, form.agent_uuid, closelightbox);
		props.changeLoader(true);
		setZPos(45)
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle style={{marginBottom: "0"}} >
					{props.contentModal["title"]}
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<DialogContent>
					<Grid container spacing={2} sx={{ marginTop: "10px" }} >
						<Grid item xs={12} >
							Se reasignaran los siguientes clientes:       
							<hr style={{margin: "6px 0 14px 0"}}/>
           				</Grid>

						{props.contentModal.customers?.map((item, index) => {
							return (
								<Grid item xs={12}  key={`customer-${index}`}>							
									{item.customer.name}
								</Grid>
						)})}

						<Grid item xs={12}>
							<hr style={{margin: "6px 0 14px 0"}}/>
							<TextField label="Agente" value={form.agent_uuid} select onChange={changeValue.bind(this, "agent_uuid")} error={error.agent_uuid !== ""} helperText={error.agent_uuid ? error.agent_uuid : ''} sx={{ marginTop: "10px" }} size="small" fullWidth >
								<MenuItem value={""}>Selecciona un agente</MenuItem>
								{props.contentModal.agents?.map((item, index) => (
									(item['status'] === 'enable'|| item['status'] === 'enabled') &&
									<MenuItem key={`agent-${index}`} value={item.uuid}>{item.name}</MenuItem>
								))}
							</TextField>              
						</Grid>          
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
					<Button disabled={disabled} variant="contained" onClick={reassign.bind(this)} >Aceptar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default ReassingnCLevel;
